import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { getSessionByUserId, getEnroleCourse } from "../../store/playList/actions";
import 'react-big-calendar/lib/sass/styles.scss';

const localizer = momentLocalizer(moment);

const MyCalendar = (props) => {
  const [state, setState] = useState({
    myEventsList: []
  });
  useEffect(()=> {
    const userType = props.profile.role;
    if(userType === "TEACHER"){
      props.getSessionByUserId();
    }else{
      props.getEnroleCourse();
    }
  }, []);

useEffect(()=> {
  if(props.playlistDetail?.allSessionList.length){
    const eventList = props.playlistDetail?.allSessionList.map(event => {
      return {
        'title': event.title,
        'allDay': true,
        'start': new Date(event.date),
        'end': new Date(event.date)
      }
    });
    setState({
      ...state,
      myEventsList: eventList
    });
  }
}, [props.playlistDetail.allSessionList]);

useEffect(()=> {
  if(props.playlistDetail?.myEnroleCourse.length){
    const eventList = props.playlistDetail?.myEnroleCourse.map(event => {
      return {
        'title': event.sessionId.title,
        'allDay': true,
        'start': new Date(event.sessionId.date),
        'end': new Date(event.sessionId.date)
      }
    });
    setState({
      ...state,
      myEventsList: eventList
    });
  }
}, [props.playlistDetail.myEnroleCourse]);

  return(
  <div>
    <Calendar
      localizer={localizer}
      events={state.myEventsList}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 500 }}
    />
  </div>
)};

const mapStateToProps = (state) => ({
  playlistDetail: state.playlist,
  profile: state.profile.profile
});

export default connect(mapStateToProps, {
  getSessionByUserId,
  getEnroleCourse
})(MyCalendar);
